import i18next from "i18next";
import { IQuantity, Quantity } from "../../../common/models/quantity.model";
import { OrderTypes } from "../../../orders/models/OrderTypes.enum";
import { translateOrderTypeName } from "../../../common/enums/orderTypes.enum";

interface IActions {
  editPrice: () => void;
  deletePrice: () => void;
  addPrice: (e: any) => void
}

export const generateItems = (quantity: IQuantity, actions: IActions, orderTypes: Array<any>) => {
  const t = i18next.getFixedT(null, "admin");
  switch (quantity) {
    case Quantity.NONE:
      const itemsArr = orderTypes.map(({ id, name }) => {
        let icon = { iconProps: {} };

        if (name === OrderTypes.VEHICLE) {
          icon = { iconProps: { iconName: "Car" } };
        } else if (name === OrderTypes.CONTAINER) {
          icon = { iconProps: { iconName: "Inbox" } };
        } else if (name === OrderTypes.WEIGHT) {
          icon = { iconProps: { iconName: "Weights" } };
        }

        return {
          key: id,
          id: id,
          text: translateOrderTypeName(name, t),
          iconProps: icon.iconProps,
          onClick: actions.addPrice,
          name: name,
          data: name
        };
      });


      return [
        {
          key: "add",
          text: t("nav.addPrice") as string,
          iconProps: { iconName: "add" },
          subMenuProps: {
            items: [...itemsArr],
          },
        },
      ];
    case Quantity.ONE:
      return [
        {
          key: "edit",
          text: t("nav.edit"),
          iconProps: { iconName: "edit" },
          name: "edit",
          onClick: actions.editPrice,
        },
        {
          key: "delete",
          text: t("nav.delete"),
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.deletePrice,
        },
      ];
    default:
      return [];
  }
};
